import { Component, forwardRef, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface FilterOption {
  value: string;
  label: string;
}

@Component({
  selector: 'app-filter-select',
  imports: [CommonModule, MatMenuModule],
  templateUrl: './filter-select.html',
  styleUrl: './filter-select.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FilterSelect),
      multi: true,
    },
  ],
})
export class FilterSelect implements ControlValueAccessor {
  @Input() options: FilterOption[] = [];
  @Input() allLabel = 'All';

  value = '';
  disabled = false;

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  get selectedLabel(): string {
    if (!this.value) {
      return this.allLabel;
    }
    return this.options.find((o) => o.value === this.value)?.label ?? this.allLabel;
  }

  writeValue(value: string): void {
    this.value = value ?? '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  select(value: string): void {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }
}
